module.exports = __webpack_public_path__ + "img/Bouvet Island (Bouvetoya).8d6ced16.svg";